













import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    noText: {
      type: Boolean,
      default: false
    }
  }
})
export default class NoData extends Vue {
}
